import logoShab from '../../../public/images/logo-shab.svg'
import Link from 'next/link'
import Image from 'next/image'
import styles from './LogoContainer.module.scss'
import Box from '@/components/UI/box/Box'

const LogoContainer = () => {
  return (
    <Box className={styles['logo-container']}>
      <Link href={'/'} className={styles['logo']} passHref>
        <Image src={logoShab} alt="سایت شب" width={96} />
      </Link>
    </Box>
  )
}

export default LogoContainer
